import {useState,useEffect } from "react";
import "./style.css";
import axios from "axios";
import moment from "moment";
import { APIURL } from "../../../Redux/Actions/config";
import { Notify } from "notiflix";
import DatePicker from "react-date-picker";
import { Document, Page, pdfjs } from "react-pdf";
import { useDispatch,useSelector } from "react-redux";
import { generatePresignedURL,CloudFileUpload } from "../../../Redux/Actions/cloudFileUpload";
import { updateBasicDetails,fetchSearch, deleteSubmission, fetchNormalSubmission } from "../../../Redux/Actions/ProfileSteps";
import { RESET_SEARCH } from '../../../Redux/Actions/types';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { Loading } from "notiflix";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const BasicDetails = ({ setCurrentStep }) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [isChanged, setIsChanged] = useState({});
  const [profileImage, setProfileImage] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);
  const [resumeRemoved, setResumeRemoved] = useState(false);
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const resumeData = useSelector(s => s.ProfileSteps.submissionData);
  const kids = useSelector(state => state.dashboard.kids);
  const search = useSelector(s => s.ProfileSteps.searchByField.homeCity);
  const [resumeFile, setResumeFile] = useState(null);
  const [resumePreview, setResumePreview] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [locationSearch, setLocationSearch] = useState('');
      const [debouncedSearch, setDebouncedSearch] = useState('');
      useEffect(() => {
          loading && Loading.standard();
  
          return () => {
              Loading.remove();
          };
      }, [loading]);
        useEffect(() => {
          // kids && kids[0]?.id && dispatch(getProfile(kids[0]?.id))
          kids && kids[0]?.id && dispatch(fetchNormalSubmission({ kid_id: kids[0]?.id, "activity_id": 1172 }))
          // kids && kids[0]?.id && dispatch(introVideoDetails({ kid_id: kids[0]?.id }))
        }, [kids])
      useEffect(() => {
          const handler = setTimeout(() => {
              setDebouncedSearch(locationSearch);
          }, 500);
  
          return () => {
              clearTimeout(handler);
          };
      }, [locationSearch]);
      useEffect(() => {
          const fetchData = async () => {
                          if (debouncedSearch.length >= 3) {
                              try {
                                  await dispatch(fetchSearch({ search_type: "homeCity", search_char: debouncedSearch, context: "homeCity" }));
                              } catch (error) {
                                  console.error("Failed to fetch locations:", error);
                              }
                          }else{
                              dispatch({ type: RESET_SEARCH })
                          }
                      };
  
          fetchData();
      }, [debouncedSearch, dispatch]);
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      if (file.size <= 25000 * 1024) { 
        setProfileImage(file);
        setProfilePreview(URL.createObjectURL(file));
         
      } else {
        alert("Image size must be less than 25KB");
      }
    } else {
      alert("Please upload a valid image file (JPEG or PNG)");
    }
  };

  const handleResumeChange = (e) => {
    const file = e.target.files[0];
    validateAndSetResume(file);
  };

  const validateAndSetResume = (file) => {
    if (file && file.type === "application/pdf") {
      if (file.size <= 25000 * 1024) {
        setResumeFile(file);
        setResumePreview(URL.createObjectURL(file));
      } else {
        alert("File size must be less than 25MB");
      }
    } else {
      alert("Please upload a PDF file");
    }
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    validateAndSetResume(file);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setIsChanged(prev => ({ ...prev, [name]: true }));
  };

const handleDobChange = (date) => {
  if (!date) {
    setFormData((prev) => ({ ...prev, birth_date: "" }));
    return;
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  
  setFormData((prev) => ({ ...prev, birth_date: formattedDate }));
};


  const handleRadioChange = (e) => {
    setFormData(prev => ({ ...prev, active_job_search: e.target.value }));
    setIsChanged(prev => ({ ...prev, active_job_search: true }));
  };
const handleUpload = async () => {
  try {
    setLoading(true);
    let uploadedImageUrl = formData.profile_image_url;
    if (profileImage && profileImage instanceof File) {
      uploadedImageUrl = await new Promise((resolve, reject) => {
        dispatch(generatePresignedURL({ filetype: "image" }, url => {
          if (!url) return reject(new Error("Failed to get presigned URL"));
          dispatch(CloudFileUpload({ url, file: profileImage }, imageUrl => {
            if (!imageUrl) return reject(new Error("Image upload failed"));
            resolve(imageUrl);
          }));
        }));
      });
    }
  const hasData = formData && Object.keys(formData).length > 0 || uploadedImageUrl ;

  if (hasData) {
        const updatedFormData = {
      ...formData,
      kid_id: kids[0]?.id,
      profile_image_url: uploadedImageUrl,
    };
    await dispatch(updateBasicDetails(updatedFormData));
  }
    if (resumeFile && resumeFile instanceof File) {

                  const zip = require("jszip")();
                  let files = resumeFile;
                      const value = zip.file(files.name,files);
                  zip.generateAsync({ type: "blob", compression: 'DEFLATE', compressionOptions: { level: 9 } }).then((content) => {
                      const imageData = new FormData();
                      imageData.append("file",content);
                      imageData.append("consent", true);
                      var config = {
                          method: 'post',
                          url: `${APIURL}/api/competition/mnprofile/submission?activityId=1172&competitionId=117&kidId=${kids[0]?.id}`,
                          headers: {
                              'accept': 'application/json',
                              'Content-Type': 'multipart/form-data',
                          },
                          data: imageData,
                      };
      
                      axios(config)
                          .then(function (response) {
                                  setLoading(false);
const hasMoveData = (
  (formData.user_name || profileData.user_name)
);


  if (hasMoveData) {
    setCurrentStep(2);
  } else {
    Notify.failure("Please fill in the required fields to proceed.");
  }    
  
                          })
                          .catch(function (error) {
                          });
                  });
    }else{
          setLoading(false);

          const hasMoveData = (
  (formData.user_name || profileData.user_name) && 
  (
    (!resumeRemoved && resumePreview) || 
    (!resumeRemoved && resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)
  )
);


  if (hasMoveData) {
    setCurrentStep(2);
  } else {
    Notify.failure("Please fill in the required fields to proceed.");
  }    
  
    }
} catch (error) {
  console.error("Upload failed:", error);
  alert(`Upload failed: ${error.message}. Please try again.`);
}
};

  const removeResume = async() => {
    setResumeFile(null);
    setResumePreview(null);
    if (profileData?.resume_details?.length > 0){
    }
    const action = dispatch(deleteSubmission(resumeData?.submission?.[0]?.csnUniqueId));
    setResumeRemoved(true);
  };
    const initialFetch = async(type, context) => {
    try {dispatch({type:RESET_SEARCH})
            await dispatch(
              fetchSearch({
                search_type: type,
                search_char: "prominentdef",
                context: context,
              })
            );
          } catch (err) {
            console.error(" search failed:", err);
          }
  }
  return (
    <>
      <div className="container-fluid">
        <div className="col-md-8 offset-md-2 py-5">
          <div className="profile-uploader pb-4">
            <a 
              className="position-relative"
              onClick={() => document.getElementById('profileImageUpload').click()}
              style={{ cursor: 'pointer' }}
            >{(profilePreview || profileData?.user_image_url) ?(
              <>
              <img 
                src={profilePreview || profileData?.user_image_url} 
                alt="profile" 
                style={{ 
                  width: '120px', 
                  height: '120px', 
                  borderRadius: '50%', 
                  objectFit: 'cover' 
                }}/>
                <span className="edit-icon">
                <img src="./svg/edit.svg" alt="edit" />
              </span>
              </>
              ):(
                <div href="" className="position-relative ">
              <img src="./svg/profile-uploader-img.svg" alt="uploader" />
            </div>
              )}
            </a>
            <input
              id="profileImageUpload"
              type="file"
              accept="image/jpeg,image/png"
              onChange={handleImageChange}
              style={{ display: 'none' }}
            />
            <div className="mt-2">
              JPEG or PNG file * <br />
              Size: Max 25KB
            </div>
          </div>

          <div className="form-bg">
            <div className="form-group placholder">
              <label htmlFor="name">
                Name<span>*</span>
              </label>
              <input
                type="text"
                name="user_name"
                className="form-control"
                placeholder="Full Name"
                value={isChanged.user_name ? formData.user_name : profileData?.user_name || ''}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="">
                Upload your resume<span>*</span>
              </label>
              {(resumeRemoved ? !resumeFile : (!resumeFile && !resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)) ? (
                <div
                  className={`drop-uploader ${isDragging ? "dragging" : ""}`}
                  onDragEnter={handleDragEnter}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onClick={() => document.getElementById("resumeUpload").click()}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <img src="./svg/download.svg" alt="" className="mb-3" />
                    <p>
                      PDF file <br />
                      Size: Max 25MB
                    </p>
                  </div>
                </div>
              ) : (
                  <div class="drop-uploader w-100 flex-column p-3">
                    <Document file={resumeRemoved ? resumePreview : (resumePreview || resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)} className="resume-image">
                      <Page
                        pageNumber={1}
                        width={300}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                      />
                        <button
                        onClick={removeResume}
                        className="remove-btn"
                        >
                        <img src="./svg/trash.svg" alt="delete" />
                        </button>
                    </Document>
                    <p className="mt-2 mb-2">
                      <strong>{resumeFile?.name || resumeData?.submission?.[0]?.activityName}</strong>
                    </p>
                  </div>
              )}
              <input
                id="resumeUpload"
                type="file"
                accept=".pdf"
                onChange={handleResumeChange}
                style={{ display: "none" }}
              />
            </div>

            <div className="form-group placholder">
              <label htmlFor="email">Email</label>
              <div className="input-group">
                <input
                  type="email"
                  name="email_id"
                  className="form-control bg-white mb-3 placholder"
                  placeholder="email@example.com"
                  value={isChanged.email_id ? formData.email_id : profileData?.email_id}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form-group placholder">
              <label htmlFor="dob">DOB</label>

            <DatePicker
                  className="form-control"
                  name="dob"
                  onChange={handleDobChange}
                  value={(formData?.birth_date && moment(formData?.birth_date).format("YYYY-MM-DD")) || (profileData?.birth_date && moment(profileData?.birth_date).format("YYYY-MM-DD"))}
                  defaultValue={new Date(moment().subtract(18, 'years'))}
                  maxDate={new Date(moment().subtract(18, 'years'))}
                  format="dd/MM/y"
                  dayPlaceholder="dd"
                  monthPlaceholder="mm"
                  yearPlaceholder="yyyy"
                />
            </div>



                                <div className='form-group'>
                                    <label htmlFor="">Gender</label>
                                    <select className='form-control' name="gender" value={ isChanged.gender ? formData.gender : profileData?.gender} onChange={handleInputChange}>
                                        <option value="Select">Select Gender</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                </div>

            <div className="form-group">
              <label>
                Actively seeking job?
              </label>
              <div className="custom-radio-main">
                <label className="radio-wrapper form-checkbox radiobox my-3">
                  <input
                    type="radio"
                    name="active_job_search"
                    className="form-check-input"
                    value="true"
                    checked={isChanged.active_job_search ? formData.active_job_search === "true" : profileData.activeJobSearch == true}
                    onChange={handleRadioChange}
                  />
                  <span className="checkmark form-check-label">Yes</span>
                </label>
                <label className="radio-wrapper form-checkbox radiobox my-3">
                  <input
                    type="radio"
                    name="active_job_search"
                    className="form-check-input"
                    value="false"
                    checked={ isChanged.active_job_search ? formData.active_job_search === "false" : profileData.activeJobSearch == false}
                    onChange={handleRadioChange}
                  />
                  <span className="checkmark form-check-label">No</span>
                </label>
              </div>
            </div>

           <div className="form-group">
  <label htmlFor="current_city">Current City</label>
  <div className="position-relative placholder">
    <input
      type="text"
      name="current_city"
      className="form-control bg-white mb-3"
      placeholder="Type 3+ characters to search"
      value={isChanged.current_city ? formData?.current_city : profileData?.current_city || ""}
      onFocus={() => initialFetch("homeCity","homeCity")}
      onChange={(e) => {
        const value = e.target.value;
        setFormData(prev => ({ ...prev, current_city: value }));
        setIsChanged(prev => ({ ...prev, current_city: true }));
        setLocationSearch(value);
      }}
    />
    {search && search.length > 0 && (
      <ul 
        className="list-group position-absolute w-100" 
        style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000, top: '100%' }}
      >
        {search.map((item, idx) => {
          return (
            <li 
              key={idx} 
              className="list-group-item list-group-item-action" 
              onClick={() => {
                setFormData(prev => ({ ...prev, current_city: item.object_name }));
                setLocationSearch('');
                setIsChanged(prev => ({ ...prev, current_city: true }));
                dispatch({type:RESET_SEARCH})
              }}
              style={{ cursor: 'pointer' }}
            >
              {item.object_name}
            </li>
          );
        })}
      </ul>
    )}
  </div>
</div>



          </div>
        </div>
      </div>

      <div className="btn-footer">
        <div className="container-fluid d-flex justify-content-lg-end">
<button
  className={`default-btn default-border bg-transparent me-3`}
  onClick={() => setCurrentStep(2)}
  disabled={!(profileData.user_name && !resumeRemoved && !!resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl)}
  style={{
    opacity: (profileData.user_name && !resumeRemoved && !!resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl) ? 1 : 0.5 ,
    cursor: (profileData.user_name && !resumeRemoved && !!resumeData?.submission?.[0]?.fileUrlDtoList?.[0]?.fileUrl) ? 'pointer' : 'not-allowed' 
  }}
>
  Skip
</button>

          <button
            className="default-btn"
            onClick={handleUpload}
          >
            Save & Next
          </button>
        </div>
      </div>
    </>
  );
};

export default BasicDetails;














// https://storage.googleapis.com/kidex-customer-app-in/EVENTS/9a60a283-4408-4d14-8c51-637890de149b1766405948681.pdf?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=kidex-dev-api%40kidex-523b7.iam.gserviceaccount.com%2F20251222%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20251222T121908Z&X-Goog-Expires=36000&X-Goog-SignedHeaders=host&X-Goog-Signature=4e1b05ed2e6e3b944e5452c3be98959caf25dbc11fb0c1d9e7028e153ebe6f25b497f307fb593300bb371caa4057a50dfb50b74d7da5b271de20f3a5a5716420725db71facdbca9eb91a150c98f76acf22ece748bca134cb5639f9185051a2a5a36b0f9e5d7d245142bc986f8b04e0b54653a9d0b195e514468f5ef43dd8a7b1cb06849d4e1cdeafcdc848154788412e982650d0e07ce981d049ccf06c2eb024e2ba0b22f1051144796d52c98144367f6745dc1bad6fa68e5abb807311d9cb2136f15bb2132bc52490f871d4e57543c8183410af5f1b141d9f9bfde1eba820767d9eed758adf82025d03e07ff05d630e752de1b067811f6c71a01d311dbae4c9